// extracted by mini-css-extract-plugin
export default {"button":"styles_button__YJK7e","textButton":"styles_textButton__ztlmC","spinner":"styles_spinner__NY0pC"};